<div class="root-div" [class.hide-router]="isLoading">
  <router-outlet></router-outlet>
</div>

@if (showPdfViewerPreload) {
  <ngx-extended-pdf-viewer [base64Src]="''"></ngx-extended-pdf-viewer>
}

<simple-notifications (create)="createNotification($event)"></simple-notifications>
@if (isLoading) {
  <spinner-rect></spinner-rect>
}

<!-- Error Banner -->
<app-error-banner></app-error-banner>
